import styled from '@marvelapp/styled';
import Box from '../Box';
export const BadgeElement = styled(Box) `
  align-items: center;
  justify-content: center;
  white-space: nowrap;
`;
